export default "__VITE_ASSET__vVqT6e9H__"